export default {
    methods: {
        generateUuid:  function (customstrong) {
            var strong = "xxxx-xxxx-4xxx-yxxx";
            if (customstrong) strong = customstrong;

//            let chars = "xxxx-xxxx-4xxx-yxxx".split("");
            let chars = strong.split("");
            for (let i = 0, len = chars.length; i < len; i++) {
                switch (chars[i]) {
                    case "x":
                        chars[i] = Math.floor(Math.random() * 16).toString(16);
                        break;
                    case "y":
                        chars[i] = (Math.floor(Math.random() * 4) + 8).toString(16);
                        break;
                }
            }
            return chars.join("");
        },
      }
}